// ========================= IMPORT DEPENDENCIES ========================= //

import { bootstrap } from '@mvps-genesis/core';
import Global from 'pages/Global';

// ========================= RUN MAIN SCRIPT ========================= //

bootstrap({

	// Pass your MVT to JS namespace
	context: window.mivaJS,

	// Global Page class
	globalClass: Global,

	// A directory of page classes or scss files to be loaded by matching the `Page_Code` context variable
	pageCodeImports: {
		BASK: () => import('pages/BASK/BASK.js'),
		CTGY: () => import('pages/CTGY/CTGY.js'),
		INVC: () => import('pages/INVC/INVC.js'),
		OCST: () => import('pages/OCST/OCST.js'),
		OPAY: () => import('pages/OPAY/OPAY.js'),
		ORDS: () => import('pages/ORDS/ORDS.js'),
		OSEL: () => import('pages/OSEL/OSEL.js'),
		// OUS1: () => import('pages/OUS1/OUS1.js'),
		// OUSM: () => import('pages/OUSM/OUSM.js'),
		PROD: () => import('pages/PROD/PROD.js'),
		PROD_GFT: () => import('pages/PROD_GFT/PROD_GFT.js'),
		SFNT: () => import('pages/SFNT/SFNT.js'),
		SRCH: () => import('pages/SRCH/SRCH'),
		WISH: () => import('pages/WISH/WISH.js'),
		WP: () => import('pages/WP/WP.js')
	},

	// A directory of page classes or scss files to be loaded by matching the `Screen` or `Page_Code` context variable against a regular expression
	regexImports: {},

	// A directory of page classes or scss files to be loaded by matching the `Screen` context variable
	screenImports: {
	}

});
